import { keyframes, styled } from 'styled-components';
import { ToastType } from './toast';

export const toastRight = keyframes`
    from {
        transform: translateX(100%);
        
    }
    to {
        transform: translateX(0);
    }
`;

export const toastLeft = keyframes`
    from {
        transform: translateX(-100%);
        
    }
    to {
        transform: translateX(0);
    }
`;

interface RootProps {
    show?: boolean;
    $type?: ToastType;
}
export const Toast = styled.div<RootProps>`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3)};
    background-color: ${({ theme, $type }) =>
        $type === ToastType.ERROR ? '#fff' : theme.toastBackground};
    border-radius: ${({ theme }) => theme.toastBorderRadius};
    border: ${({ theme, $type }) =>
        $type === ToastType.ERROR ? `2px solid ${theme.errorColor}` : theme.toastBorder};
    box-shadow: ${({ theme, $type }) =>
        $type === ToastType.ERROR ? '0 4px 20px rgba(225, 31, 29, 0.15)' : theme.toastShadow};
    margin: 0;
    /* 300px, but on the narrowest phones that is more than the screen leaves
       beside the stack's 24px from the right edge: keep 24px on the left too. */
    max-width: min(300px, calc(100vw - ${({ theme }) => theme.spacing(12)}));
    padding: ${({ theme }) => theme.spacing(4)} ${({ theme }) => theme.spacing(4)};
    width: ${({ theme }) => theme.spacing(75)};
    animation: ${toastRight} 0.7s;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
        transform: translateX(-4px);
    }
`;

export const Root = styled.div`
    bottom: ${({ theme }) => theme.spacing(6)};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3)};
    position: fixed;
    right: ${({ theme }) => theme.spacing(6)};
    z-index: 9999;
`;
